import React, { Component } from 'react'

export default class Messengers extends Component {
  render() {
    return (
      <div className="Messengers">
        <div className="Messengers__container">
          <input type="checkbox" id="messegners" className='Messengers__checkbox'/>
          <label htmlFor="messegners" className='Messengers__label'/>
          <div className="Messengers__buttons-wrapper">
            <a className="Messengers__button" href='https://t.me/+79295477002' target="_blank">
              <img src="/assets/img/communication_channels/telegram-icon-dark.png" alt="telegram" />
            </a>
            <div className="Messengers__button Messengers__button_main">
              <img src="/assets/img/question-mark.png" alt="message" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Messengers.jsx